import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import TextButton from '../../../../../Buttons/TextButton';
import s from './CancelButton.scss';
const CancelButton = (_param)=>{
    var { children  } = _param, rest = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(TextButton, _extends({
        size: "large",
        variant: "main",
        className: s['root']
    }, rest), children);
};
CancelButton.displayName = 'CancelButton';
export default CancelButton;
